import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.confirmationModal = null
    this.totpModal = null
  }

  showConfirmation(event) {
    event.preventDefault()
    
    const accountName = document.getElementById('account_name').value
    const startAdminEmail = document.querySelector('input[name="start_admin_email"]')?.value
    
    // Display organization name in modal
    document.getElementById('orgNameDisplay').textContent = accountName || '[Org Name]'
    
    // Show confirmation modal
    const modalElement = document.getElementById('confirmCreateModal')
    this.confirmationModal = new bootstrap.Modal(modalElement)
    this.confirmationModal.show()
  }

  confirmCreate(event) {
    event.preventDefault()
    
    // Hide confirmation modal
    if (this.confirmationModal) {
      this.confirmationModal.hide()
    }
    
    // Check if current admin has TOTP enabled
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'
    
    if (currentAdminHasTotp) {
      // Use reusable TOTP verification modal
      this.showTotpModal()
    } else {
      // Submit form directly
      this.submitForm()
    }
  }

  showTotpModal() {
    // Get form data
    const formData = this.getFormData()
    
    // Use the reusable TOTP verification modal
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.getActionUrl(),
        actionMethod: this.getActionMethod(),
        formData: formData
      }
    })
    document.dispatchEvent(event)
  }

  getFormData() {
    const formData = {
      account: {
        name: document.getElementById('account_name').value,
        enable_totp: document.getElementById('enable_totp_switch')?.checked || false
      }
    }
    
    // Add start admin email if present (only for create)
    const startAdminEmail = document.querySelector('input[name="start_admin_email"]')?.value
    if (startAdminEmail) {
      formData.start_admin_email = startAdminEmail
    }
    
    return formData
  }

  getActionUrl() {
    const isEdit = window.location.pathname.includes('/edit')
    return isEdit ? window.location.pathname.replace('/edit', '') : '/accounts'
  }

  getActionMethod() {
    const isEdit = window.location.pathname.includes('/edit')
    return isEdit ? 'PATCH' : 'POST'
  }

  submitForm() {
    // Create form data
    const formData = new FormData()
    
    // Add account data
    formData.append('account[name]', document.getElementById('account_name').value)
    formData.append('account[enable_totp]', document.getElementById('enable_totp_switch')?.checked || false)
    
    // Add start admin email if present (only for create)
    const startAdminEmail = document.querySelector('input[name="start_admin_email"]')?.value
    if (startAdminEmail) {
      formData.append('start_admin_email', startAdminEmail)
    }
    
    // Determine if this is an edit or create action
    const isEdit = window.location.pathname.includes('/edit')
    const method = isEdit ? 'PATCH' : 'POST'
    const url = isEdit ? window.location.pathname.replace('/edit', '') : '/accounts'
    
    // Submit to appropriate action
    fetch(url, {
      method: method,
      body: formData,
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => {
      if (response.redirected) {
        window.location.href = response.url
      } else {
        return response.json()
      }
    })
    .then(data => {
      if (data && data.require_totp) {
        // Show TOTP modal
        const totpModalElement = document.getElementById('totpVerificationModal')
        this.totpModal = new bootstrap.Modal(totpModalElement, {
          backdrop: 'static',
          keyboard: false
        })
        this.totpModal.show()
      } else if (data && data.error) {
        // Handle error
        alert(data.error)
      } else if (data && data.success) {
        window.location.href = data.redirect_url
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
  }
} 